
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Activity, CheckCircle } from 'lucide-react';

const SystemHealthMonitor = () => {
  return (
    <Card className="bg-gray-800 border-gray-700">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-white">
          <Activity className="h-5 w-5 text-sports-green" />
          System Health Monitor
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div className="flex items-center gap-2 text-gray-300">
            <CheckCircle className="h-4 w-4 text-green-500" />
            <span>Server Status</span>
          </div>
          <div className="flex items-center gap-2 text-gray-300">
            <CheckCircle className="h-4 w-4 text-green-500" />
            <span>Memory Usage</span>
          </div>
          <div className="flex items-center gap-2 text-gray-300">
            <CheckCircle className="h-4 w-4 text-green-500" />
            <span>Response Times</span>
          </div>
          <p className="text-sm text-gray-400 mt-4">
            System performance is within normal parameters.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default SystemHealthMonitor;
